import { h } from "preact";
import { useEffect, useRef, useState } from "preact/hooks";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";
import Container from "../../components/container";
import BaseForm from "../../components/form";
import { TextHeader } from "../../components/text";
import { COULMN_DATA } from "./constants/columns";
import { useGetData } from "./hook/useGetData";
import { ContainerData, ContainerSearch, ContainerTable } from "./style/style";
import { EditData } from "./view/modal/edit";
import { TableData } from "./view/table/data";
import qurrystring from "query-string";
import { PrimaryButton } from "../../components/button/primary";
import { SecondaryButton } from "../../components/button/secondary";
import { useGetOption } from "./hook/useGetOption";
import { Divider } from "antd";
import { useDelete } from "./hook/useDelete";
import { IModelRef } from "./interfaces/modal";
import { IPropsResult, IStateChangeDevice } from "./interfaces/state";
import { FORM_SEARCH } from "./constants/forms";
import WrapperComponent from "../../components/hoc/WrapperComponent";
import { useDispatch } from "react-redux";
import * as changeDeviceAction from "../../redux/changDevice/action";

const ChangeDeviceScene = () => {
  const modalRef = useRef<IModelRef>();
  const { onDelete } = useDelete();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const pl = params.get("p");
  const { data, setData, onFetchData, onSearch } = useGetData();
  const { onFetchOptionChangeDevice, optionsChangeDevice } = useGetOption();
  const [loadingTable, setLoadingTable] = useState(true);
  const [forceLoadingSearch, setForceLoadingSearch] = useState(false);
  const [forceLoading, setForceLoading] = useState(false);
  const { control, setValue, getValues, reset, handleSubmit } = useForm({});
  const dispatch = useDispatch();

  const onFetchSearch = async () => {
    pl && (await onSearch(pl));
    setForceLoading(false);
  };

  useEffect(() => {
    onFetchOptionChangeDevice();
  }, []);

  useEffect(() => {
    setLoadingTable(true);
    onFetchSearch();
    setLoadingTable(false);
  }, [pl]);

  useEffect(() => {
    const firstFetchData = async () => {
      setLoadingTable(true);
      await onFetchData();
      setLoadingTable(false);
    };
    firstFetchData();
  }, []);

  const onSubmitSearch = async () => {
    const {
      search_maintainChangeId,
      search_maintainId,
      search_deviceId,
      search_customerCode,
      search_saleCode,
      search_maintainChangeStatus,
    } = getValues();
    const valueParams = {
      maintainChangeId: search_maintainChangeId,
      maintainId: search_maintainId,
      deviceId: search_deviceId,
      customerCode: search_customerCode,
      saleCode: search_saleCode,
      maintainChangeStatus: search_maintainChangeStatus,
    };
    const queryString = qurrystring.stringify(valueParams);
    setForceLoadingSearch(true);
    setLoadingTable(true);
    window.history.replaceState(null, "", `change?${queryString}`);
    await onSearch(queryString);
    setLoadingTable(false);
    setForceLoadingSearch(false);
  };

  const onSubmitClearSearch = async (force?: boolean) => {
    reset();
    const deviceId = getValues().search_id;
    const lotId = getValues().search_pl;
    const status = getValues().search_status_device;
    const ValueParams = {
      deviceId: deviceId,
      lotId: lotId,
      status: status,
    };
    const queryString = qurrystring.stringify(ValueParams);
    force && setForceLoading(true);
    setLoadingTable(true);
    window.history.replaceState(null, "", `?${queryString}`);
    await onFetchData();
    setLoadingTable(false);
    force && setForceLoading(false);
  };

  function onCallbackEdit(item: IStateChangeDevice, result: IPropsResult) {
    const findIndex = data.findIndex(
      (e) => e.maintainChangeId === item.maintainChangeId
    );
    if (findIndex === -1) {
      return;
    }
    const d = JSON.parse(JSON.stringify(data));
    d[findIndex].maintainChangeStatus = "STCH-100";
    d[findIndex].addressName = item.postalAddressName;
    d[findIndex].customerCode = item.customerCode;
    d[findIndex].postalAddressId = item.postalAddressId;
    d[findIndex].axJournalId = result.axJournalId;
    d[findIndex].axVoucher = result.axVoucher;
    d[findIndex].journalId = result.journalId;
    setData(d);
    dispatch(
      changeDeviceAction.changeDeiveEdit(
        d.filter((e: any) => e.maintainChangeStatus === "STCH-001")
      )
    );
  }

  const onCallbackDelete = async (item: IStateChangeDevice) => {
    const findIndex = data.findIndex(
      (e) => e.maintainChangeId === item.maintainChangeId
    );
    if (findIndex === -1) {
      return;
    }
    const d = JSON.parse(JSON.stringify(data)) as IStateChangeDevice[];
    const { maintainChangeId } = d[findIndex];
    const res = await onDelete(`${maintainChangeId}`);
    if (!res) {
      return;
    }
    d[findIndex].maintainChangeId = "COMPLETE-CONFIRM";
    d.splice(findIndex, 1);
    setData(d.map((e, i) => ({ ...e, index: i + 1 })));
    dispatch(
      changeDeviceAction.changeDeviceDelete(
        d.filter((e: any) => e.maintainChangeStatus === "STCH-001")
      )
    );
  };

  return (
    <Container>
      <TextHeader text={"แลกเปลี่ยนอุปกรณ์"} divider={true} />
      <ContainerData>
        <BaseForm
          control={control}
          forms={FORM_SEARCH({ optionsChangeDevice, onSubmitSearch })}
          setValue={setValue}
          getValues={getValues}
        />
        <ContainerSearch>
          <PrimaryButton
            label={"ค้นหา"}
            style={{ marginLeft: "10px" }}
            mobileStyle={{ marginTop: "10px", marginRight: "5px" }}
            tabletStyle={{ marginTop: "10px", marginRight: "5px" }}
            isLoading={forceLoadingSearch}
            forceLoading={forceLoadingSearch}
            onPress={handleSubmit(onSubmitSearch)}
          />
          <SecondaryButton
            label={"ล้างข้อมูล"}
            style={{ marginLeft: "10px" }}
            mobileStyle={{ marginTop: "10px", marginRight: "5px" }}
            tabletStyle={{ marginTop: "10px", marginRight: "5px" }}
            isLoading={forceLoadingSearch}
            forceLoading={forceLoading}
            onPress={onSubmitClearSearch}
          />
        </ContainerSearch>
      </ContainerData>
      <Divider />
      <ContainerTable>
        <TableData
          columns={COULMN_DATA({
            onEdit: (e: IStateChangeDevice) =>
              modalRef.current && modalRef.current.openModal(e),
            onDelete: (e: IStateChangeDevice) => onCallbackDelete(e),
          })}
          data={data}
          loading={loadingTable}
        />
      </ContainerTable>
      <EditData
        ref={modalRef}
        onCallbackEdit={(e: IStateChangeDevice, result: IPropsResult) =>
          onCallbackEdit(e, result)
        }
      />
    </Container>
  );
};

export default WrapperComponent("ChangeDeviceScene")(ChangeDeviceScene);
